import React, { useState } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Bate no endpoint de login que criamos no Node
      const response = await api.post('/auth/login', { email, password });
      
      // Salva o JWT e o nome do usuário no navegador
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user_name', response.data.user.name);
      localStorage.setItem('user_email', response.data.user.email);
      
      // Redireciona para a área administrativa
      navigate('/jb-acesso-master-control-cms');
    } catch (err) {
      console.error('Erro no login:', err);
      setError('E-mail ou senha incorretos. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="card p-4 shadow-lg border-0" style={{ maxWidth: '400px', width: '100%' }}>
        <div className="text-center mb-4">
          <h2 className="fw-light text-dark">CMS Jurerê Blue</h2>
          <p className="text-muted small">Acesso Restrito ao Painel</p>
        </div>

        {error && <div className="alert alert-danger py-2 small">{error}</div>}

        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label small fw-bold">E-MAIL</label>
            <input 
              type="email" 
              className="form-control form-control-lg fs-6" 
              placeholder="seu@email.com"
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              required 
            />
          </div>

          <div className="mb-4">
            <label className="form-label small fw-bold">SENHA</label>
            <input 
              type="password" 
              className="form-control form-control-lg fs-6" 
              placeholder="••••••••"
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required 
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-dark w-100 py-3 fw-bold"
            disabled={loading}
          >
            {loading ? 'AUTENTICANDO...' : 'ENTRAR NO PAINEL'}
          </button>
        </form>

        <div className="text-center mt-4">
          <a href="/" className="text-decoration-none text-muted small">← Voltar para o Site</a>
        </div>
      </div>
    </div>
  );
};

export default Login;